import { AddressInputConfig } from '../DataInputs/AddressInput/AddressInput';
import { DateInputConfig } from '../DataInputs/DateInput/DateInput';
import { PhoneInputConfig } from '../DataInputs/PhoneInput/PhoneInput';
import { SSNInputConfig } from '../DataInputs/SSNInput/SSNInput';
import { SimpleTextInputConfig } from '../DataInputs/SimpleTextInput/SimpleTextInput';
import { StateInputConfig } from '../DataInputs/StateInput/StateInput';
import { ZipCodeInputConfig } from '../DataInputs/ZipCodeInput/ZipCodeInput';
import { CaptchaConfig } from './Captcha/Captcha';
import { CheckboxInputConfig } from './CheckboxInput/CheckboxInput';
import { CountySelectorConfig } from './CountySelector/CountySelector';
import { EmailInputConfig, EmailInputWithMatchConfig } from './EmailInput/EmailInput';
import { MoneyInputConfig } from './MoneyInput/MoneyInput';
import { PasswordInputConfig, PasswordInputWithStrengthConfig } from './PasswordInput/PasswordInput';
import { PercentageInputConfig } from './PercentageInput/PercentageInput';
import { RadioGroupInputConfig } from './RadioGroupInput/RadioGroupInputWrapper';
import { SelectInputConfig } from './SelectInput/SelectInput';
import { RequirementInputConfig } from './RequirementInput/RequirementInput';
import { SSNVerificationInputConfig } from './UnformattedNumberInput/UnformattedNumberInput';
import { UnformattedNumberInputConfig } from './UnformattedNumberInput/UnformattedNumberInput';
import { UnformattedRequirementInputConfig } from './RequirementInput/UnformattedRequirementInput';
import { ToggleInputConfig } from './ToggleInput/ToggleInput';

interface InputMap {
  [InputName: string]: FormInputConfig;
}

const InputMap: InputMap = {
  AddressInput: AddressInputConfig,
  Captcha: CaptchaConfig,
  CheckboxInput: CheckboxInputConfig,
  CountySelector: CountySelectorConfig,
  DateInput: DateInputConfig,
  EmailInput: EmailInputConfig,
  EmailInputWithMatch: EmailInputWithMatchConfig,
  MoneyInput: MoneyInputConfig,
  PasswordInput: PasswordInputConfig,
  PasswordInputWithStrength: PasswordInputWithStrengthConfig,
  PercentageInput: PercentageInputConfig,
  PhoneInput: PhoneInputConfig,
  RadioGroupInput: RadioGroupInputConfig,
  SelectInput: SelectInputConfig,
  SimpleTextInput: SimpleTextInputConfig,
  SSNInput: SSNInputConfig,
  SSNVerificationInput: SSNVerificationInputConfig,
  StateInput: StateInputConfig,
  RequirementInput: RequirementInputConfig,
  UnformattedNumberInput: UnformattedNumberInputConfig,
  UnformattedRequirementInput: UnformattedRequirementInputConfig,
  ZipCodeInput: ZipCodeInputConfig,
  ToggleInput: ToggleInputConfig,
};

export default InputMap;
